import * as z from "zod";

export const startShipStationApiSync = {
  name: "startShipStationApiSync" as const,
  input: z.object({}),
  output: z.object({ workflowId: z.string() }),
};
